import type { FC } from "react";

export const PlaybookEditorLoadingState: FC = () => (
  <div className="flex h-64 items-center justify-center text-muted-foreground">
    <p className="text-sm">Loading playbook...</p>
  </div>
);
